module.exports = __webpack_public_path__ + "img/AI (7).bee6f9f3.png";